import { onBeforeMount, ref } from 'vue'

import { useConfigStore } from '~/store/config'
import { b64JsonDecode } from '~/lib/base64'

import { ApiRecord } from '~/types/records/ApiRecord'
import { AlgoliaRecord, PathRecord } from '~/types/records/AlgoliaRecord'

import GarbanzoApi from '~/services/garbanzo-api/GarbanzoApi'


const decodeRecord = (encRecord: string): BaseRecord => b64JsonDecode(encRecord)

export function useExternalContent(encRecord: string) {
  const algoliaRecord = decodeRecord(encRecord) as AlgoliaRecord | PathRecord
  const apiRecord = ref<ApiRecord | null>(null)
  const hasApiData = ref(false)

  onBeforeMount(async () => {
    const client = new GarbanzoApi(useConfigStore().config.API_BASE_URL)
    const { type, uuid } = algoliaRecord
    apiRecord.value = await client.getByType(type, uuid)
    hasApiData.value = true
  })

  return {
    apiRecord,
    hasApiData,
    algoliaRecord,
  }
}
